import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpSharedConditionModalWrapper" */
        './PdpSharedConditionModalWrapper'
    ).then(({ PdpSharedConditionModalWrapper }) => PdpSharedConditionModalWrapper);
};

function PdpSharedConditionModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpSharedConditionModalLoader.propTypes = {
    itemId: PropTypes.string.isRequired,
    environment: PropTypes.object.isRequired,

    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { PdpSharedConditionModalLoader };
